import cx from 'classnames';
import styles from './BalanceInfo.module.scss';

import { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useIncreaseBalance } from '../lib/useIncreaseBalance';
import { useAppSelector } from '@app/store';
import { PATH } from '@app/index';
import { useEffectOnChange, useMultiClick } from '@utils/hooks';
import { PlusIcon } from '@assets/icons';
import { Typography } from '@shared/Typography';

export const BalanceInfo: FC = () => {
  const nav = useNavigate();
  const userBalance = useAppSelector((state) => state.user.userData?.balance);
  const noGamesAnimation = useAppSelector((s) => s.lottery.noGamesAnimation);

  const [firstData, setFirstData] = useState(true);
  const [balance, setBalance] = useState(
    userBalance ? Math.trunc(Number(userBalance) * 100) / 100 : 0,
  );
  const [prevBalance, setPrevBalance] = useState('');
  const [growth, setGrowth] = useState<boolean | undefined>();

  const { handleIncreaseBalance } = useIncreaseBalance();

  const location = useLocation();

  const handleClick = useMultiClick({
    onSingleClick: () => nav(PATH.PROFILE),
    onTripleClick: () => {
      if (userBalance) handleIncreaseBalance('15');
    },
    delay: 500,
  });

  useEffectOnChange(() => {
    if (userBalance !== undefined) {
      if (firstData) {
        setPrevBalance(userBalance);
        setFirstData(false);
        return;
      }

      setGrowth(undefined);
      const t = setTimeout(() => {
        if (Number(userBalance) > Number(prevBalance)) {
          setGrowth(true);
        } else {
          setGrowth(false);
        }
        setPrevBalance(userBalance);
      }, 100);

      return () => clearTimeout(t);
    }
  }, [userBalance]);

  useEffect(() => {
    if (userBalance !== undefined && noGamesAnimation)
      setBalance(Math.trunc(Number(userBalance) * 100) / 100);
  }, [userBalance, noGamesAnimation]);

  const isAccountPage = location.pathname === PATH.ACCOUNT;

  return (
    <div
      onClick={handleClick}
      className={styles.balanceContainer}
      data-tutorial="balance"
    >
      <img
        width={32}
        height={32}
        alt="dollar"
        src={'/images/dollar.webp'}
        className={styles.balanceIcon}
      />
      <div className={styles.balanceBox}>
        <Typography
          component="h2"
          className={cx(
            styles.balance,
            growth === true
              ? styles.balanceGold
              : growth === false
                ? styles.balanceGray
                : '',
          )}
        >
          {balance}
        </Typography>
      </div>

      {!isAccountPage && (
        <div className={styles.balancePlus}>
          <PlusIcon className={styles.balancePlusIcon} />
        </div>
      )}
    </div>
  );
};
